import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../authentication/auth.service';
import { DialogService } from '../dialogs/dialogs.service';
import { SplashService } from '../splash/splash.service';
import { UserService } from 'services/user/user.service';
import { UnsavedChangesService } from 'routes/routes.guard';
import * as i0 from "@angular/core";
import * as i1 from "../authentication/auth.service";
import * as i2 from "../dialogs/dialogs.service";
import * as i3 from "../splash/splash.service";
import * as i4 from "../../routes/routes.guard";
import * as i5 from "../user/user.service";
var ErrorService = /** @class */ (function () {
    function ErrorService(authService, dialogService, splashService, unsavedChangesService, userService) {
        this.authService = authService;
        this.dialogService = dialogService;
        this.splashService = splashService;
        this.unsavedChangesService = unsavedChangesService;
        this.userService = userService;
    }
    // #region Handle Service Error Service Call
    ErrorService.prototype.HandleServiceError = function (error, user) {
        var _this = this;
        var self = this;
        var status = null;
        var msg = null;
        if (error instanceof HttpErrorResponse) {
            status = error.status;
            var body = error && error.error;
            msg = body.ExceptionMessage || body.Message || body || 'An unknown error has occurred.';
        }
        else {
            var errorPacket = error.message || error;
            if (errorPacket != null && errorPacket !== '') {
                try {
                    errorPacket = JSON.parse(errorPacket);
                }
                catch (_a) {
                    errorPacket = errorPacket;
                }
            }
            msg =
                errorPacket != null && errorPacket instanceof Object
                    ? errorPacket.ExceptionMessage || errorPacket.Message || error
                    : errorPacket || 'An unknown error has occurred.';
        }
        self.splashService.CloseSplash();
        var handled = false;
        if (status === 401) {
            // This is an unauthorized response. Check the msg field. If it matches the string 'AuthToken Expired', the user's authtoken has
            // expired and the user needs to log back in.
            if (msg === 'AuthToken Expired') {
                // It's an expired authtoken. Set the flag that we've handled this error, and we'll do a relogin dialog.
                handled = true;
                // Cancel authtoken refreshing - pointless now anyway
                self.authService.CancelAuthTokenRefreshing();
                // Pop up a dialog box to let the user log in again and stay on this screen.
                self.dialogService
                    .OpenLoginBoxDialog({
                    TitleText: 'Session Timed Out - Please Re-Login',
                    MessageText: "Your current session to the IRIS System appears to have timed out due to inactivity or " +
                        "network disconnection. Before you can continue, please login again using the login form " +
                        "provided below.<br /><br /><strong><span style=\"color:red\">Note: </span></strong>The operation you were " +
                        "just attempting did not succeed, but your data on this page (if any) has not been lost. After you log " +
                        "back in to the IRIS System, you may attempt the operation once again.",
                    OKText: 'Login',
                    CancelText: 'Cancel',
                    Username: user && user.AccountName,
                })
                    .subscribe(function (credentials) {
                    if (credentials != null) {
                        // Attempt to log back in using the provided credentials
                        self.authService
                            .RevalidateSession(credentials.Username, credentials.Password, user && user.AuthToken, user && user.SAPID, user != null ? user.IsImpersonation : false)
                            .subscribe(function (userinfo) {
                            if (userinfo) {
                                // We can now update the authtoken we just received for this user.
                                self.userService.UpdateAuthToken(userinfo.AuthToken);
                                // Toast successful revalidation
                                self.splashService.SnackbarSuccess('Session revalidated successfully. Please retry the last request.', 6000);
                            }
                        }, function (rerror) {
                            self.HandleServiceError(rerror);
                        });
                    }
                    else {
                        // User cancelled. First, disable any pending unsaved changes
                        self.unsavedChangesService.ClearTracking();
                        // Now logout.
                        self.authService.Logout(false);
                    }
                });
            }
        }
        if (!handled && status === 408) {
            // This is a Request Timeout response, indicating the user's session has expired.
            handled = true;
            this.dialogService
                .OpenMessageBoxDialog({
                TitleText: 'Session Timed Out',
                MessageText: "Your current session to the Journey System has timed out and your login access has been closed. " +
                    "In order to continue using the Journey System you will need to login again to the system.",
            })
                .subscribe(function (res) {
                // Force an unconfirmed logout to clear user stored values and return to the login screen.
                _this.authService.Logout(false, 2);
            });
        }
        if (!handled) {
            // Something else, which should be snackbar displayed.
            this.splashService.SnackbarError(msg, 8000);
        }
    };
    // #endregion
    // #region Retrieve Service Error Service Call
    ErrorService.prototype.RetrieveServiceError = function (error) {
        if (error instanceof HttpErrorResponse) {
            var body = error && error.error;
            var msg = body.ExceptionMessage || body.Message || body || (typeof body === 'string' ? body : 'An unknown error has occurred.');
            return {
                ErrorMessage: msg,
                ErrorObject: error,
            };
        }
        else {
            // Try to get a sensible message, then create a fake HttpErrorResponse object
            var errorPacket = error.message || error;
            if (errorPacket != null && errorPacket !== '') {
                try {
                    errorPacket = JSON.parse(errorPacket);
                }
                catch (_a) {
                    errorPacket = errorPacket;
                }
            }
            var msg = errorPacket != null && errorPacket instanceof Object
                ? errorPacket.ExceptionMessage || errorPacket.Message || error
                : errorPacket || 'An unknown error has occurred.';
            var errObject = new HttpErrorResponse({
                error: error,
                status: 500,
                statusText: msg,
            });
            return {
                ErrorMessage: msg,
                ErrorObject: errObject,
            };
        }
    };
    // #endregion
    // #region Retrieve Service Error Message Service Call
    ErrorService.prototype.RetrieveServiceErrorMessage = function (error) {
        var status = null;
        var msg = null;
        if (error instanceof HttpErrorResponse) {
            status = error.status;
            var body = error && error.error;
            msg =
                body.ExceptionMessage || body.Message || body || (typeof body === 'string' ? body : 'An unknown error has occurred.');
        }
        else {
            var errorPacket = error.message || error;
            if (errorPacket != null && errorPacket !== '') {
                errorPacket = JSON.parse(errorPacket);
            }
            msg =
                errorPacket != null && errorPacket instanceof Object
                    ? errorPacket.ExceptionMessage || errorPacket.Message || error
                    : errorPacket || 'An unknown error has occurred.';
        }
        if (status === 408) {
            // This is a Request Timeout response, indicating the user's session has expired.
            msg = 'Your current session to the IRIS System has timed out and is no longer valid.';
        }
        return msg;
    };
    ErrorService.ngInjectableDef = i0.defineInjectable({ factory: function ErrorService_Factory() { return new ErrorService(i0.inject(i1.AuthService), i0.inject(i2.DialogService), i0.inject(i3.SplashService), i0.inject(i4.UnsavedChangesService), i0.inject(i5.UserService)); }, token: ErrorService, providedIn: "root" });
    return ErrorService;
}());
export { ErrorService };
// #region Custom Classes
// #region Error Info Class
var ErrorInfo = /** @class */ (function () {
    function ErrorInfo() {
    }
    return ErrorInfo;
}());
export { ErrorInfo };
